import React from 'react';
import ErpTablePage from '../components/ErpTablePage';

const BankReconciliation = () => {
  return <ErpTablePage moduleKey="bank_reconciliation" />;
};

export default BankReconciliation;